import "./goBack.scss";
import { useNavigate } from "react-router-dom";

// icon
import { goBackIcon } from "../../../constants/icons";

interface GoBackProp{
    goback: string
}

const GoBack = ({goback}:GoBackProp) => {
    const navigate = useNavigate()
  return (
    <div className="goback">
        <button className="btnHolder" onClick={()=>{
            navigate(goback)
        }}>
            {goBackIcon}
        </button>
    </div>
  )
}

export default GoBack